import _slicedToArray from "/Users/sdq/GitHub/visact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { Bounds, intersect } from 'vega-scenegraph';
import { array } from 'vega-util';
export default function (b, opt, group) {
  if (!b) return [];

  var _b = _slicedToArray(b, 2),
      u = _b[0],
      v = _b[1],
      box = new Bounds().set(u[0], u[1], v[0], v[1]),
      scene = group || this.context.dataflow.scenegraph().root;

  return intersect(scene, box, filter(opt));
}

function filter(opt) {
  var p = null;

  if (opt) {
    var types = array(opt.marktype),
        names = array(opt.markname);

    p = function p(_) {
      return (!types.length || types.some(function (t) {
        return _.marktype === t;
      })) && (!names.length || names.some(function (s) {
        return _.name === s;
      }));
    };
  }

  return p;
}